import React from 'react'
import './maps.css';
import FullHeight from 'react-full-height';



const MapContainer = () => {
    return (
    <FullHeight className="section sectionFillViewport" id="maps">
                <iframe
                        title="map-rgb-ziegetsdorfer"
                        width="100%"
                        height="100%"
                        className="gmap_canvas"
                        src="https://maps.google.com/maps?q=ziegetsdorfer%20strasse%2032%2093051%20regensburg&t=&z=15&ie=UTF8&iwloc=&output=embed"
                        scrolling="no"
                        loading="lazy"
                        referrerPolicy="no-referrer-when-downgrade"
                ></iframe>
                <iframe
                        title="map-kelheim"
                        width="100%"
                        height="100%"
                        className="gmap_canvas"
                        src="https://maps.google.com/maps?q=donaustrasse%2014%2093309%20kelheim&t=&z=15&ie=UTF8&iwloc=&output=embed"
                        scrolling="no"
                        loading="lazy"
                        referrerPolicy="no-referrer-when-downgrade"
                ></iframe>
                <iframe
                        title="map-rgb-maximilianstr"
                        width="100%"
                        height="100%"
                        className="gmap_canvas"
                        src="https://maps.google.com/maps?q=maximilianstrasse%2024%2093047%20regensburg&t=&z=15&ie=UTF8&iwloc=&output=embed"
                        scrolling="no"
                        loading="lazy"
                        referrerPolicy="no-referrer-when-downgrade"
                ></iframe>
        </FullHeight>

    );
}


export default MapContainer;